import { sortCOPSModelToParam, sortParamToCOPSModel } from 'utils/helpers';
import { boardIdTypes } from '../common/gantt/config/view';
import { defaultGanttView, ganttDefaultSortColumn, urlSigns } from '../utils/app-configs';

const decideInitialGanttView = (viewsArray, match, planningAndViewToOpen) => {
    if (viewsArray.length) {
        if (planningAndViewToOpen?.id) {
            return viewsArray?.find(v => v.isNone);
        }
        if (match.params.ganttView) {
            const viewFromUrl = viewsArray?.find(v => v.id === match.params.ganttView);
            if (viewFromUrl) {
                const activeSort = sortCOPSModelToParam(viewFromUrl.sorting);
                const sortParam = match.params.ganttSort === activeSort ?
                    activeSort :
                    match.params.ganttSort || activeSort;
                const filterData = match.params.ganttFilters === viewFromUrl.filterData ?
                    viewFromUrl.filterData :
                    match.params.ganttFilters || viewFromUrl.filterData;
                const viewObject = {
                    ...viewFromUrl,
                    sorting: sortParamToCOPSModel(
                        sortParam ||
                        // eslint-disable-next-line max-len
                        `${ganttDefaultSortColumn}${urlSigns.keyValueSeparator}true${urlSigns.sortIndexSeparator}0`,
                    ),
                    filterData: filterData || '',
                };
                if (viewFromUrl?.sorting[0]?.manualSort) {
                    viewObject.sorting[0].manualSort = viewFromUrl?.sorting[0]?.manualSort;
                }
                return viewObject;
            }
            // View does not exist in viewarray of user =>
            // default to none but with url params if exist
            const noneView = viewsArray?.find(v => v.isNone);
            return {
                ...noneView,
                sorting: sortParamToCOPSModel(
                    match.params.ganttSort ||
                    // eslint-disable-next-line max-len
                    `${ganttDefaultSortColumn}${urlSigns.keyValueSeparator}true${urlSigns.sortIndexSeparator}0`,
                ),
                filterData: match.params.ganttFilters || '',
            };
        }
        return viewsArray?.find(v => v.isDefault) || viewsArray?.find(v => v.isNone);
    }
    return {
        id: `${boardIdTypes.service}_none`,
        ...defaultGanttView,
    };
};

export default decideInitialGanttView;
